import React, { useEffect, useState } from 'react';
import SidebarSecond from '../../components/Sidebar/SidebarSecond';
import { useDispatch, connect } from 'react-redux';
import './AdditionalStagesPage.scss';
import { AdditionalStagesProps } from './types';
import Sidebar from '../../components/Sidebar/Sidebar';
import {
    editAdditionalExercisesDialogParams,
    editAdditionalStageDialogParams,
    additionalStageDialogParams,
    additionalExercisesDialogParams,
} from './consts';
import FormDialog from '../../components/FormDialog/FormDialog';
import { AppState } from '../../store/rootReducer';
import { getLanguagesList } from '../../store/languages/selectors';
import { requestGetList } from '../../store/languages/actions';
import { getAdditionalStagesList } from '../../store/additionalStages/selectors';
import { requestGetAdditionalStagesList, requestSaveAdditionalStage } from '../../store/additionalStages/actions';
import { AdditionalStage } from '../../store/additionalStages/types';
import strings from '../../resources/strings';
import { requestGetListRewards } from '../../store/rewards/actions';
import RewardTypes from '../../resources/enums/RewardTypes';
import { AdditionalComponent, FormDialogProps } from '../../components/FormDialog/types';
import { validateLanguages } from '../../utils/Validator';
import { requestGetMissionsList } from '../../store/missions/actions';
import { getMissionsList } from '../../store/missions/selectors';
import { getRewardsList } from '../../store/rewards/selectors';
import { getAdditionalExercisesList } from '../../store/additionalExercises/selectors';
import {
    requestDeleteExercise,
    requestGetAdditionalExercisesList,
    requestSaveAdditionalExercise,
} from '../../store/additionalExercises/actions';
import { AdditionalExercise } from '../../store/additionalExercises/types';
import TasksContainer from '../../components/TasksContainer/TasksContainer';
import { getTaskTypesList } from '../../store/taskTypes/selectors';
import { Task } from '../../store/tasks/types';
import { requestDeleteTask, requestGetListTasks, requestSaveTasks } from '../../store/tasks/actions';
import { getTasksList } from '../../store/tasks/selectors';
import { getAdditionalExercisesRewards } from '../../utils/RewardsHeler';
import { getDefaultLang } from '../../utils/LanguageHelper';
import { status } from '../../utils/StatusCalculator';
import SidebarSecondStatuses from '../../resources/enums/SidebarSecondStatuses';
import DeleteCircleButton from '../../components/Buttons/DeleteCircleButton';
import { requestGetTaskTypesList } from '../../store/taskTypes/actions';

const AdditionalStagesPage: React.FC<AdditionalStagesProps> = (props) => {
    const [currentStage, setCurrentStage] = useState<AdditionalStage>();
    const [currentExercise, setCurrentExercise] = useState<AdditionalExercise>();
    const [languageValue] = React.useState(getDefaultLang(props.languages));
    const [deleteEnabled, setDeleteEnabled] = useState<boolean>(false);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(requestGetList());
        dispatch(requestGetAdditionalStagesList());
        dispatch(requestGetListRewards());
        dispatch(requestGetMissionsList());
        dispatch(requestGetTaskTypesList());
    }, []);

    useEffect(() => {
        if (!currentStage) setCurrentStage(props.additionalStages[0]);
        if (currentStage) setCurrentStage(props.additionalStages.find((x) => x.id === currentStage?.id));
    }, [props.additionalStages]);

    useEffect(() => {
        if (currentStage?.additionalExercises && exercisesRefresh)
            dispatch(requestGetAdditionalExercisesList(currentStage.additionalExercises));
        setDeleteEnabled(
            status(currentStage?.publishTo ?? null, currentStage?.publishFrom ?? null) !== SidebarSecondStatuses.active,
        );
    }, [currentStage]);

    useEffect(() => {
        if (currentExercise?.tasks && currentExercise.tasks.length > 0)
            dispatch(requestGetListTasks(currentExercise.tasks));
    }, [currentExercise]);

    const exercisesRefresh = !currentStage?.additionalExercises?.every((x) => {
        return props.additionalExercises
            .map((y) => {
                return y.id;
            })
            .includes(x);
    });

    editAdditionalStageDialogParams.handleSubmit = additionalStageDialogParams.handleSubmit = (
        data: object,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
        setError?: React.Dispatch<React.SetStateAction<boolean>>,
    ) => {
        if (!validateLanguages([data], props.languages.length)) {
            if (setError) setError(true);
            return;
        } else if (currentStage) {
            let stage = data as AdditionalStage;
            if (currentStage?.id === stage.id) {
                stage = { ...stage, additionalExercises: currentStage?.additionalExercises };
            }
            dispatch(requestSaveAdditionalStage(stage));
            setOpen(false);
        }
    };

    editAdditionalExercisesDialogParams.handleSubmit = additionalExercisesDialogParams.handleSubmit = (
        data: object,
        setOpen: React.Dispatch<React.SetStateAction<boolean>>,
        setError?: React.Dispatch<React.SetStateAction<boolean>>,
    ) => {
        if (!validateLanguages([data], props.languages.length)) {
            if (setError) setError(true);
            return;
        } else if (currentStage) {
            const modifiedCurrendExercise = data as AdditionalExercise;
            const rewards = getAdditionalExercisesRewards(
                modifiedCurrendExercise,
                currentStage,
                props.additionalExercises,
            );
            dispatch(requestSaveAdditionalExercise({ ...currentStage, rewards: rewards }, modifiedCurrendExercise));
            setCurrentExercise(modifiedCurrendExercise);
            setOpen(false);
        }
    };

    const getAdditionalMissionsList = () => {
        return props.additionalStages.map((x) => {
            return {
                ...x,
                courses: props.missionsList,
            };
        });
    };
    const getAdditionalExercisesList = (exercisesId: string[]) => {
        return props.additionalExercises
            .filter((item) => exercisesId.includes(item.id))
            .map((x) => {
                return {
                    ...x,
                    missionSkills: getRelatedMissionSkills(),
                    proficiencies: props.rewards.filter((x) => x.type === RewardTypes.Proficiency),
                };
            });
    };

    const getAddAdditionalStageParams = () => {
        return {
            ...additionalStageDialogParams,
            component: {
                ...additionalStageDialogParams.component,
                data: [
                    {
                        courses: props.missionsList,
                    },
                ],
            } as AdditionalComponent,
        } as FormDialogProps;
    };

    const getAddAdditionalExerciseParams = () => {
        return {
            ...additionalExercisesDialogParams,
            component: {
                ...additionalExercisesDialogParams.component,
                data: [
                    {
                        missionSkills: getRelatedMissionSkills(),
                        proficiencies: props.rewards.filter((x) => x.type === RewardTypes.Proficiency),
                    },
                ],
            } as AdditionalComponent,
        } as FormDialogProps;
    };

    const handleSubmitTasks = (tasks: Task[]) => {
        if (!(currentStage && currentExercise)) return;
        const modifiedCurrendExercise = {
            ...currentExercise,
            tasks: tasks.map((item) => {
                return item.id;
            }),
        };
        setCurrentExercise(modifiedCurrendExercise);
        dispatch(requestSaveTasks(tasks));
        dispatch(requestSaveAdditionalExercise(currentStage, modifiedCurrendExercise));
    };

    const getRelatedMissionSkills = () => {
        return props.missionsList.find((x) => x.id === currentStage?.relatedMission)?.skills;
    };

    const deleteTask = (id: string) => {
        if (!(currentStage && currentExercise)) return;
        const modifiedCurrendExercise = {
            ...currentExercise,
            tasks: currentExercise?.tasks?.filter((x) => x !== id),
        } as AdditionalExercise;
        setCurrentExercise(modifiedCurrendExercise);
        dispatch(requestSaveAdditionalExercise(currentStage, modifiedCurrendExercise));
        dispatch(requestDeleteTask(id));
    };

    const deleteAdditionalExercise = (id: string) => {
        if (!currentStage) return;
        const modifiedCurrendStage = {
            ...currentStage,
            additionalExercises: currentStage?.additionalExercises?.filter((x) => x !== id),
        } as AdditionalStage;
        const tasks = props.additionalExercises.find((x) => x.id === id)?.tasks ?? [];
        setCurrentStage(modifiedCurrendStage);
        dispatch(requestSaveAdditionalStage(modifiedCurrendStage));
        dispatch(requestDeleteExercise(id, tasks));
        if (currentExercise?.id === id) setCurrentExercise(undefined);
    };

    return (
        <div className="content">
            <Sidebar></Sidebar>
            <SidebarSecond
                data={getAdditionalMissionsList()}
                actualLanguage={languageValue}
                actualItemId={currentStage?.id}
                title={strings.additionalMissions.missionsTitle}
                isAddNew={true}
                setActualItemId={(id: string) => {
                    setCurrentStage(props.additionalStages.find((el) => el.id === id));
                    setCurrentExercise(undefined);
                }}
                hideStatus={false}
                addButton={{ component: FormDialog, params: getAddAdditionalStageParams(), languages: props.languages }}
                editButton={{
                    component: FormDialog,
                    params: editAdditionalStageDialogParams,
                    languages: props.languages,
                }}
            ></SidebarSecond>
            {currentStage ? (
                <>
                    <SidebarSecond
                        data={getAdditionalExercisesList(currentStage.additionalExercises)}
                        actualLanguage={languageValue}
                        actualItemId={currentExercise?.id}
                        title={strings.missions.exercisesTitle}
                        isAddNew={true}
                        setActualItemId={(id: string) => {
                            setCurrentExercise(props.additionalExercises.find((el) => el.id === id));
                        }}
                        hideStatus={true}
                        addButton={{
                            component: FormDialog,
                            params: getAddAdditionalExerciseParams(),
                            languages: props.languages,
                        }}
                        editButton={{
                            component: FormDialog,
                            params: editAdditionalExercisesDialogParams,
                            languages: props.languages,
                        }}
                        deleteButton={
                            deleteEnabled
                                ? {
                                      component: DeleteCircleButton,
                                      params: {
                                          action: (id?: string) => {
                                              if (id) deleteAdditionalExercise(id);
                                          },
                                      },
                                  }
                                : undefined
                        }
                    ></SidebarSecond>
                    {currentExercise ? (
                        <TasksContainer
                            languages={props.languages}
                            taskTypes={props.taskTypes}
                            skills={getRelatedMissionSkills()?.filter((item) =>
                                currentExercise.skills?.includes(item.id),
                            )}
                            tasks={
                                currentExercise.tasks && currentExercise.tasks.length > 0
                                    ? props.tasks.filter((item) => currentExercise.tasks?.includes(item.id))
                                    : []
                            }
                            handleSubmit={handleSubmitTasks}
                            deleteEnabled={deleteEnabled}
                            deleteTask={deleteTask}
                        ></TasksContainer>
                    ) : (
                        ''
                    )}
                </>
            ) : (
                ''
            )}
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        languages: getLanguagesList(state),
        additionalStages: getAdditionalStagesList(state),
        additionalExercises: getAdditionalExercisesList(state),
        missionsList: getMissionsList(state),
        rewards: getRewardsList(state),
        taskTypes: getTaskTypesList(state),
        tasks: getTasksList(state),
    };
}

export default connect(mapStateToProps)(AdditionalStagesPage);
